import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isInternal, wantsWeb } from 'base/lib/route_to'

function findNearestLink(el) {
  let node = el
  while (node) {
    if (node.tagName === 'A') {
      return node
    }
    node = node.parentNode
  }

  return null
}

function ManualLinkRouter({ history, children }) {
  function clickHandler(event) {
    const link = findNearestLink(event.target)
    if (!link) {
      return
    } else if (wantsWeb(link.href)) {
      window.location.href = link.href
      return
    } else if (!isInternal(link.href)) {
      return
    }

    event.preventDefault()
    const route = link.href.replace(`${link.protocol}//${link.host}`, '')
    history.push(route)
  }

  return <div onClick={clickHandler}>{children}</div>
}

ManualLinkRouter.propTypes = {
  history: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
}

export default withRouter(ManualLinkRouter)
